import React from "react";
import {useDispatch} from "react-redux";
import {MinLoader, TextToolTip} from "components";
import {UploadAvatar} from "./uploadAvatar";
import {ChangePassword} from "./changePassword";
import {FindLoad, isAdmin, useModal} from "utils";
import {authActions} from "store";
import {ExportBson} from "fragments";
import {Svg} from "assets";

export const MyProfile = ({info}) => {
    const dispatch = useDispatch();
    const loader = FindLoad("LOG_OUT");
    const {openModal} = useModal();

    const handleSignOut = () => {
        dispatch(authActions.logOut());
    };

    const handleOpenDatabaseExport = () => {
        openModal(
            <ExportBson/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 610,
            }
        );
    };

    return (
        <div className="my-profile-wrapper">
            {(info?.avatar?.url ||
                info?.firstName ||
                info?.lastName ||
                info?.email) && (
                <div className="my-profile-user-info">
                    {(info?.avatar?.url || info?.firstName || info?.lastName) && (
                        <div className="my-profile-user-avatar-wrapper">
                            {info?.avatar?.url ? (
                                <img src={info?.avatar?.url} alt="avatar"/>
                            ) : (
                                (info?.firstName || info?.lastName) && (
                                    <p className="my-profile-user-FLName">
                                        {`${
                                            info?.firstName ? info?.firstName?.[0]?.toUpperCase() : ""
                                        } ${info?.lastName ? info?.lastName?.[0]?.toUpperCase() : ""}`}
                                    </p>
                                )
                            )}
                        </div>
                    )}

                    {(info?.firstName || info?.lastName || info?.email) && (
                        <div className="my-profile-info-maile">
                            {(info?.firstName || info?.lastName) && (
                                <TextToolTip
                                    classNameText="my-profile-user-flName"
                                    content={`${info?.firstName ? info?.firstName : ""} ${info?.lastName ? info.lastName : ""}`}
                                    text={`${info?.firstName ? info?.firstName : ""} ${info?.lastName ? info.lastName : ""}`}
                                />
                            )}

                            {info?.email && (
                                <TextToolTip
                                    classNameText="my-profile-user-email"
                                    content={info?.email ? info?.email : "N/A"}
                                    text={info?.email ? info?.email : "N/A"}
                                />
                            )}
                        </div>
                    )}
                </div>
            )}

            <div className="uploaded-avatar-change-pass-wrapper">
                <UploadAvatar/>
                {isAdmin && <ChangePassword/>}
                {isAdmin && (
                    <div className="change-pass-wrapper">
                        <div className="upload-avatar-svg_title-edit-btn">
                            <div className="upload-avatar-svg_title">
                                <Svg.DatabaseSvg/>
                                <p className="upload-avatar-title">Database Export</p>
                            </div>

                            <div
                                onClick={handleOpenDatabaseExport}>
                                <Svg.ExportCSVSvg
                                    style={{
                                        filter: 'brightness(0) saturate(100%) invert(94%) sepia(8%) saturate(5092%) hue-rotate(171deg) brightness(90%) contrast(96%)',
                                        cursor: "pointer"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <button className="my-profile-log-out-btn" onClick={handleSignOut}>
                {loader?.length ? (
                    <MinLoader margin={"0"} color={"#FE7070"}/>
                ) : (
                    <>
                        <Svg.SignOutSvg/>
                        Log Out
                    </>
                )}
            </button>
        </div>
    );
};
